import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "./Modal.scss";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LoadingOverlay from "react-loading-overlay-ts";
import { API_PATH } from "../utility";

export default function Gallery(props) {
  const [show, setShow] = useState(props.show);
  const [itemInd, setInd] = useState(0);
  const [flightInfo, setFlightInfo] = useState(props.flight);
  const [galImages, setGalImages] = useState([]);
  const [isResolving, setIsResolving] = useState(false);

  // Derived loader — single source of truth, no timing gap
  const gLoader = isResolving;

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    setFlightInfo(props.flight);
    const photos = props.flight.aircraftPicture || [];

    if (photos.length === 0) {
      setGalImages([]);
      setIsResolving(false);
      return;
    }

    setIsResolving(true); // show loader immediately
    setGalImages([]); // clear stale images from previous aircraft

    const resolvePhoto = (photo) => {
      if (photo.imageSource === "AVIANIS") {
        return fetch(`${API_PATH}white_label/avianis/${photo.imageId}`)
          .then((res) => {
            if (!res.ok) throw new Error();
            return res.blob();
          })
          .then((blob) => URL.createObjectURL(blob))
          .catch(() => null);
      } else if (photo.imageSource !== "AVIANIS") {
        return Promise.resolve(photo.url || null);
      } else {
        return Promise.resolve(null);
      }
    };

    Promise.all(photos.map(resolvePhoto)).then((resolvedUrls) => {
      const validUrls = resolvedUrls.filter(Boolean);
      setGalImages(validUrls);
      setIsResolving(false); // hide loader only after ALL images are resolved
    });
  }, [props.flight]);

  const sliderChange = (e) => {
    setInd(parseInt(e.target.value));
  };

  const closeGal = () => {
    props.closeGallery(false);
    setInd(0);
  };

  const galTitleRef = useRef(null);

  const handleSwipeEnd = () => {
    if (itemInd >= galImages.length - 1) {
      setInd(galImages.length - 1);
    }
  };

  return (
    <>
      <Modal
        show={show}
        fullscreen={"true"}
        onHide={() => closeGal()}
        dialogClassName="modal-100w"
      >
        <Modal.Header>
          <Modal.Title>
            <div className="title_ctr">
              <div>
                <div className="back_btn" onClick={() => closeGal()}>
                  &lt; Back
                </div>
                <div className="close_btn" onClick={() => closeGal()}>
                  &#10006;
                </div>
              </div>
              {flightInfo.hasOwnProperty("aircraftType") &&
                flightInfo.aircraftType !== null && (
                  <h3 className="gal_title" ref={galTitleRef}>
                    {flightInfo.aircraftType}
                  </h3>
                )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="img-wrapper">
            <Carousel
              autoPlay={false}
              selectedItem={itemInd}
              showThumbs={false}
              onChange={(index) => {
                if (index < galImages.length) {
                  setInd(index);
                } else {
                  setInd(galImages.length - 1);
                }
              }}
              onSwipeEnd={handleSwipeEnd}
            >
              {galImages.length > 0
                ? galImages.map((url, gInd) => (
                    <div className="img-cont" key={`gal-img-${gInd}`}>
                      <img
                        src={url}
                        alt={`gal-img-${gInd}`}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    </div>
                  ))
                : !isResolving && <div>No aircraft photos found...</div>}
            </Carousel>
          </div>

          {galImages.length > 1 && (
            <input
              type="range"
              name="itemInd"
              value={itemInd}
              min="0"
              step="1"
              max={galImages.length - 1}
              onChange={(e) => sliderChange(e)}
              style={{ border: "none", outline: "none" }}
            />
          )}

          <LoadingOverlay
            active={gLoader}
            spinner
            text="Loading aircraft images"
            fadeSpeed="1000"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
